
export class DateIndexationUtils {
    static masterCalendarDict = (seconds, calendarId, map) => {
        return parseInt(map.get(`mcd:${seconds}:${calendarId}`))
    }

    static specificCalendarDict = (index, calendarId, map) => {
        return parseInt(map.get(`scd:${calendarId}:${index}`))
    }

    static masterWorkPatternDict = (index, calendarId, map) => {
        return parseInt(map.get(`mwp:${index}:${calendarId}`))
    }

    static convertIndexToSeconds(index, calendarId, map) {
        const date = this.specificCalendarDict(index, calendarId, map)
        if (isNaN(date)) {
            return this.convertOutOfRangeIndexToDate(index, calendarId, map)
        } else {
            return date
        }
    }

    static convertOutOfRangeDateToIndex(date, calendarId, map) {
        const maxDate = parseInt(map.get(`swp:maxDate:${calendarId}`))
        const maxIndex = parseInt(map.get(`swp:maxIndex:${calendarId}`))
        const halfHours = parseInt(map.get(`swp:wi:count:${calendarId}`))
        const weeks = Math.floor((date - maxDate) / 604800)
        const maxWeekIndex = parseInt(map.get(`swp:maxWeekIndex:${calendarId}`))
        const relativeMaxWeekIndex = this.masterWorkPatternDict(maxWeekIndex, calendarId, map)
        const remainingHalfHours = Math.floor((date - maxDate) / 1800) - (weeks * 336)
        const newMasterIndex = remainingHalfHours + maxWeekIndex > 336 ? (remainingHalfHours + maxWeekIndex) - 336 : remainingHalfHours + maxWeekIndex
        const newCalendarSpecificIndex = this.masterWorkPatternDict(newMasterIndex, calendarId, map)

        const newIndex = remainingHalfHours + maxWeekIndex > 336 ? maxIndex + (weeks * halfHours) + (halfHours - relativeMaxWeekIndex) + (newCalendarSpecificIndex) :
            maxIndex + (weeks * halfHours) + (newCalendarSpecificIndex - relativeMaxWeekIndex)

        return newIndex
    }

    static convertDateToIndex(date, calendarId, map) {
        let index = this.masterCalendarDict(date, calendarId, map)
        if (isNaN(index)) {
            return this.convertOutOfRangeDateToIndex(date, calendarId, map)
        }
        return index
    }

    static convertOutOfRangeIndexToDate(index, calendarId, map) {
        const maxDate = parseInt(map.get(`swp:maxDate:${calendarId}`))
        const maxIndex = parseInt(map.get(`swp:maxIndex:${calendarId}`))
        const halfHours = parseInt(map.get(`swp:wi:count:${calendarId}`))
        const weeks = Math.floor((index - maxIndex) / halfHours)
        const maxWeekIndex = parseInt(map.get(`swp:maxWeekIndex:${calendarId}`))
        const relativeMaxWeekIndex = this.masterWorkPatternDict(maxWeekIndex, calendarId, map)
        const relativeMaxDayIndex = parseInt(map.get(`swp:maxDayIndex:${calendarId}`))
        const relativeMaxHalfHourIndex = parseInt(map.get(`swp:wi:h:${calendarId}:${relativeMaxWeekIndex}`))
        const remainingHalfHours = index - maxIndex - (weeks * halfHours)
        const newIndex = remainingHalfHours + relativeMaxWeekIndex > halfHours ? (remainingHalfHours + relativeMaxWeekIndex) - halfHours : remainingHalfHours + relativeMaxWeekIndex
        const newWeekDayIndex = parseInt(map.get(`swp:wi:d:${calendarId}:${newIndex}`))
        const additionalDays = relativeMaxWeekIndex + remainingHalfHours > halfHours ? 7 - relativeMaxDayIndex + newWeekDayIndex : newWeekDayIndex - relativeMaxDayIndex

        return maxDate + (weeks * 604800) + (additionalDays * 86400) + ((parseInt(map.get(`swp:wi:h:${calendarId}:${newIndex}`)) - relativeMaxHalfHourIndex) * 1800)
    }

    static getOutOfRangeLateralIndex (index, calendarId, lateralCalendarId, addOn, calendarsMap) {
        if (calendarId === lateralCalendarId) {
            return index + addOn
        }
        const date = this.convertOutOfRangeIndexToDate(index, calendarId, calendarsMap)
        const maxDate = calendarsMap.get(`swp:maxDate:${lateralCalendarId}`)
        const maxIndex = calendarsMap.get(`swp:maxIndex:${lateralCalendarId}`)
        const weekCount = Math.floor((date - maxDate - 1800 - (3 * 86400)) / 604800)
        const weekHalfHourCount = calendarsMap.get(`swp:wi:count:${lateralCalendarId}`)
        const weekIndexDatePlusWeeks = (((maxDate + (weekCount * 604800)) - 1800 - (3 * 86400)) -
            Math.floor(((maxDate + (weekCount * 604800)) - 1800 - (3 * 86400)) / 604800) * 604800) / 1800
        const correspondingCalendarIndexDatePlusWeeks = this.masterWorkPatternDict(weekIndexDatePlusWeeks, lateralCalendarId, calendarsMap)
        const weekIndexDate = ((date - 1800 - (3 * 86400)) - Math.floor((date - 1800 - (3 * 86400)) / 604800) * 604800) / 1800
        const correspondingCalendarIndexDate = this.masterWorkPatternDict(weekIndexDate, lateralCalendarId, calendarsMap)
        const indicesToAdd = correspondingCalendarIndexDatePlusWeeks < correspondingCalendarIndexDate ?
            correspondingCalendarIndexDate - correspondingCalendarIndexDatePlusWeeks :
            weekHalfHourCount - correspondingCalendarIndexDatePlusWeeks + correspondingCalendarIndexDate

        return maxIndex + (weekCount * weekHalfHourCount) + indicesToAdd + addOn
    }

    static getLateralIndex (
        index: number,
        calendarId: string,
        lateralCalendarId: string,
        addOn: number,
        calendarsMap: Map<string, any>
    ) {
        if (calendarId === lateralCalendarId) {
            return index + addOn
        } else {
            const lateralIndex = this.masterCalendarDict(this.specificCalendarDict(index, calendarId, calendarsMap), lateralCalendarId, calendarsMap)
            if (!isNaN(lateralIndex)) {
                if (this.specificCalendarDict(index, calendarId, calendarsMap) === this.specificCalendarDict(lateralIndex, lateralCalendarId, calendarsMap)) {
                    return lateralIndex + addOn
                } else {
                    return lateralIndex
                }
            } else {
                return this.getOutOfRangeLateralIndex(index, calendarId, lateralCalendarId, addOn, calendarsMap)
            }
        }
    }
}
